import { render, staticRenderFns } from "./ProjectProposedModal.vue?vue&type=template&id=3b7fa1b8&scoped=true&"
import script from "./ProjectProposedModal.vue?vue&type=script&lang=js&"
export * from "./ProjectProposedModal.vue?vue&type=script&lang=js&"
import style0 from "./ProjectProposedModal.vue?vue&type=style&index=0&id=3b7fa1b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7fa1b8",
  null
  
)

export default component.exports